export const prepare_preview = function () {
  if (window.context_name !== 'preview') {
    // GRYP-12156: Removes the Google Tag Manager <noscript> element
    // from index.html when not in the Preview context
    // Note: We are aware that if they've got JavaScript disabled,
    // none of this will actually do anything, but *shrugs*
    var noscript = document.getElementById('gtm-noscript');
    if (noscript) {
      noscript.parentNode.removeChild(noscript);
    }

    return;
  }

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  try {
    const ivw =
      params.ivwBE && params.ivwBE !== ''
        ? params.ivwBE.replace(/\/+$/, '')
        : null;
    if (ivw) {
      window.__ivwBE = ivw;
    }
  } catch (e) {}

  (function () {
    const html = Gryphon.templates['preview-debug-panel']();
    $('<div>', { id: 'previewDebugPanel', html }).appendTo('#main_cont');
  })();

  $(document).ready(function () {
    const setupDebugPanelEvents = () => {
      if (localStorage.getItem('preview-debug-panel') === 'open') {
        $('#collapseOne').addClass('in');
      }
      $('#previewDebugPanel').on('shown', function () {
        localStorage.setItem('preview-debug-panel', 'open');
      });
      $('#previewDebugPanel').on('hidden', function () {
        localStorage.removeItem('preview-debug-panel');
      });
    };
    setupDebugPanelEvents();
  });
};

export const load_preview = function () {
  if (window.context_name !== 'preview') return;
  const initializeDebugPanelState = () => {
    window.page_state = window.page_state || {};
    window.page_state.preview_data = {};
    var pathargs = window.location.pathname.split('/');
    window.page_state.preview_data['visa'] = pathargs[2];
    window.page_state.preview_data['survey'] = pathargs[3];
    window.page_state.preview_data['version'] = pathargs[4];
    window.page_state.preview_data['__facebook__'] = {
      authResponse: {
        accessToken: 'accessToken',
        userID: '1234567890',
      },
      permissions: ['user_likes', 'email', 'public_profile'],
      status: 'connected',
      first_name: 'Test',
      id: '1234567890',
    };
    var pd = window.page_state.preview_data;
    pd['update_url'] = [
      localStorage.getItem('ivw_be') || '',
      'preview/u',
      pd.visa,
      pd.survey,
      pd.version,
    ].join('/');
  };

  initializeDebugPanelState();

  // Show session_summary data in console for Previews [GRYP-5962]
  if (page_state.hasOwnProperty('preview_data')) {
    const baseForRequest =
      window.__ivwBE && window.__ivwBE !== ''
        ? window.__ivwBE
        : localStorage.getItem('ivw_be') || window.location.origin;
    const url =
      baseForRequest.replace(/\/+$/, '') +
      '/preview/session_summary/' +
      page_state['preview_data'].visa;

    $.ajax({
      type: 'GET',
      url,
      xhrFields: {
        withCredentials: true,
      },
      global: false,
      success: function (session_summary) {
        try {
          var parsed =
            typeof session_summary === 'string'
              ? JSON.parse(session_summary)
              : session_summary;
          console.log(
            new Date().toGMTString() + '\n -- SESSION SUMMARY -- ',
            parsed
          );

          window.session_summary = parsed;
          let target = '#previewDebugPanel .accordion-inner';
          if (JsonView) {
            JsonView.renderJSON(
              window.session_summary,
              document.querySelector(target)
            );
            document.querySelector('#previewDebugPanel');
          }

          try {
            if (window.__ivwBE) {
              localStorage.setItem('ivw_be', window.__ivwBE);
            }
          } catch (e) {}
        } catch (e) {
          console.error('Error parsing session_summary response\n', e);
        }
      },
      error: function (res, status, error) {
        if (status !== 'error' || !window.newrelic) return;

        const errorMessage = `Error while loading preview session summary: ${error} (status code: ${res.status})`;
        window.newrelic.noticeError(new Error(errorMessage), {
          errorMessage,
          response: res.statusText,
          status: res.status,
          requestURL: url,
          method: 'GET',
          ajaxErrorListener: false,
        });
      },
    });
  }
};
